import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormInputNumberComponent} from './form-input-number.component';
import {SharedModule} from '../../../modules/shared/shared.module';
import {FormInputErrorModule} from '../form-input-error/form-input-error.module';
import {InputNumberModule} from 'primeng/inputnumber';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [
    FormInputNumberComponent
  ],
  exports: [
    FormInputNumberComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormInputErrorModule,
    InputNumberModule,
    FormsModule
  ]
})
export class FormInputNumberModule {
}
